import { TitleValidator } from '~/validators'
import stripe from '~/mixins/stripe.js'
import modalSignup from '~/mixins/modalSignup.js'
import signupIframe from '~/components/Molecules/OrganicSquad/SignupIframe/SignupIframe.vue'

export default {
  mixins: [modalSignup, stripe],

  props: {
    title: {
      type: [String, Object],
      required: true,
      validator: prop => TitleValidator(prop, 'title'),
    },

    body: {
      type: String,
    },

    background: {
      type: Object,
      required: true,
    },

    buttons: {
      type: Array,
    },

    logo: {
      type: Object,
    },
  },

  components: {
    signupIframe,
  },

  computed: {
    isTitleTypeString() {
      return typeof this.title === 'string' ? true : false
    },
  },
}
